/**
 * Paths available to users who are not logged in
 * @constant
 */
export const PUBLIC_PATHS = {
  LANDING: "/",
  
  MY_ESTATE: "/my-estate",

};



/**
 * Paths available to users who are  logged in
 * @constant
 */
export const PROTECTED_PATHS = {
  MY_ESTATE: "/my-estate",
  SIGNUP: "/signup",


  //IdCard
  ID_CARD: "/IdCard",
  REQUEST_ID: "/Request-id",

  // Chat
  CHAT: "/chat-with-MyEstateNG"
};

export const DATA_ROWS = {
  LIMIT: 20,
};
